import React, { Component } from 'react'
import './max_list_popup.scss';
import cur_icon_close_gre from '../../../images/cur_icon_close_gre.png'
import download_icon from '../../../images/overall_data/download_icon.png'
import cur_icon_search from "../../../images/emotion_analysis/cur_icon_search.png"
import ChartList from '../chart_list'
import OpenBlankList from "../open_blank_list"
import BlankList from '../blank_list'
import DetailOptionList from './detail_option_list'
import MatrixNpsList from '../Matrix_nps_chart/matrix_nps_list'
import debounce from 'lodash/debounce';
import { Input, Empty, ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale/zh_CN';
export default class max_list_popup extends Component {
    constructor(props) {
        super(props);
        this.resize = debounce(this.resize, 1000);
        this.maxChartRef = React.createRef();
        this.state = {
            dataList: { name: "", type: "" },
            single_id: "",
            chart_flag: 0,// 0 为饼图 1 为 列表
            isConsumer: false,
            isMaxSreen: false,
            blankListHeight: 0,
            desired_user_list: [],
            desired_user_list_formal: [],
            desired_user_list_prev: [],
            isShowRightDetail: true, // 是否展示右边列表
            search_text: "",
            bar_option_name: ""// 当前所选择的柱子
        }

    }
    setMaxChart(obj) {
        this.debounceFunc = this.resize.bind(this);
        window.addEventListener("resize", this.debounceFunc, false);
        let { dataList, single_id, isConsumer } = obj
        this.setState({
            dataList: dataList,
            single_id: single_id,
            isConsumer: isConsumer,
            search_text: ""
        }, () => {
            this.resize("first_enter")
            // this.props.toInitChart()
        })
    }
    componentDidMount() {
        this._isMounted = true
        if (this._isMounted) {
            // this.setState({
            //   dataList: this.props.dataList
            // })
            // this.toInitChart()
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.setState = () => { }
    }
    componentDidUpdate() {
        if (this._isMounted && this.state.needRefresh) {
            if (this.state.desired_user_list?.length >= 0 && this.state.isShowRightDetail) {
                let max_chart_left = document.getElementById("max_chart_" + this.state.single_id)
                max_chart_left.style.cssText = `width: 45%`
                let max_chart_right = document.getElementById("max_chart_right_" + this.state.single_id)
                max_chart_right.style.cssText = `width: 55%`
                this.judgeResetChart()
            } else if (this.state.desired_user_list === null) {
                // let max_chart_left = document.getElementById("max_chart_" + this.state.single_id)
                // max_chart_left.style.cssText = `width: 100%`
            }
            this.setState({
                needRefresh: false
            })
        }
    }
    static getDerivedStateFromProps(props, state) {
        if (JSON.stringify(props.desired_user_list) !== JSON.stringify(state.desired_user_list_prev)) {
            return {
                needRefresh: true,
                desired_user_list: props.desired_user_list,
                desired_user_list_formal: props.desired_user_list,
                desired_user_list_prev: props.desired_user_list,
                isShowRightDetail: true,
                search_text: ""
            }
        }
        return null;

    }
    // 判断是否要重新渲染chart
    judgeResetChart() {
        let type = this.state.dataList.type
        if (type === 2 || type === 1 || type === 7 || type === 12 || type === 13) {
            let dom = document.getElementById("max_chart_" + this.state.single_id)
            if (!dom) { return; }
            let domWidth = dom.offsetWidth;
            if (domWidth !== this.state.domWidth && domWidth <= 800) {
                this.props.toInitChart(false)
            }
        }

    }
    resize(flag) {
        let isMaxSreen = this.state.isMaxSreen
        let sreenWidth = document.body.clientWidth
        let type = this.state.dataList.type
        let dom = document.getElementById("max_chart_popup_" + this.state.single_id)
        if (!dom) { return; }
        let domWidth = dom.offsetWidth;
        let domWHeight = dom.offsetHeight;
        if (type === 11) { // 特殊的自定义 因为下面有foot
            this.props.toInitChart()
            return
        }
        if (domWidth > 800) {
            if (isMaxSreen === false || flag === "first_enter") { // 之前是false
                if (type === 3 || type === 15 || type === 16 || type === 18) {//简答题
                    let blankDom = document.getElementById("max_chart_" + this.state.single_id + "_wrapper")
                    let blankDomHeight = blankDom.offsetHeight - 140;
                    this.setState({ blankListHeight: blankDomHeight })
                } else {
                    this.props.toInitChart(true)
                }
                this.setState({ isMaxSreen: true })
            }
        } else {
            if (isMaxSreen === true || flag === "first_enter") { // 之前是true
                if (type === 3 || type === 15 || type === 16 || type === 18) {//简答题
                    let blankDom = document.getElementById("max_chart_" + this.state.single_id + "_wrapper")
                    let blankDomHeight = blankDom.offsetHeight - 140;
                    this.setState({ blankListHeight: blankDomHeight })
                } else {
                    this.props.toInitChart(false)
                }
                this.setState({ isMaxSreen: false })
            }
        }
        if (type === 2 || type === 1 || type === 12 || type === 13) {
            let blankDom = document.getElementById("max_chart_" + this.state.single_id + "_wrapper")
            let blankDomHeight = blankDom.offsetHeight - 260;
            this.setState({ blankListHeight: blankDomHeight })
        }
        let chartDom = document.getElementById("max_chart_" + this.state.single_id)
        let chartDomWidth = 0
        if (chartDom) {
            chartDomWidth = chartDom.offsetWidth;
        }
        this.setState({
            chartDomWidth: chartDomWidth
        })
    }
    tags_close() {
        this.props.canShowMaxChartPopup({ showMaxChartPopup: false })
    }
    download() {
        this.props.downloadChart()
    }
    // 切换图
    handleChangeChart(index) {
        if (this.state.chart_flag === index) {
            return
        }
        this.setState({
            chart_flag: index
        })
    }
    // 切换词云
    handleWordCloud(index) {
        this.handleChangeChart(index)
        if (!this.props.wordcloud_image) {
            this.props.geWordCloudQuestion()
        }
        // if (!this.state.dataList.hasOwnProperty('wordcloud_image')) {
        //     this.props.geWordCloudQuestion()
        // }
    }
    // 点击柱子
    onMouseDown() {
        let Xindex = JSON.parse(localStorage.getItem("Xindex"))
        if (!Xindex || (this.state.dataList.type !== 2 && this.state.dataList.type !== 1 && this.state.dataList.type !== 12 && this.state.dataList.type !== 13)) {
            return
        }
        let bar_index = ""
        let bar_option_id = ""
        let bar_option_name = ""
        if (this.state.dataList.type === 2) {
            bar_index = Xindex[0].dataIndex;
            bar_option_id = this.state.dataList.option_id_list[bar_index];
            bar_option_name = this.state.dataList.xAxisList[bar_index];
        } else if (this.state.dataList.type === 1 || this.state.dataList.type === 12 || this.state.dataList.type === 13) {
            bar_index = Xindex.dataIndex;
            bar_option_id = this.state.dataList.data[bar_index].option_id;
            bar_option_name = this.state.dataList.data[bar_index].name;
        }
        localStorage.removeItem('Xindex')
        this.setState({
            bar_option_name: bar_option_name
        })
        this.props.getRelatedCommentList(bar_option_id, bar_option_name, true)
    }
    //是否展示右边的详情
    handleShowRightDetail() {
        this.setState({
            isShowRightDetail: !this.state.isShowRightDetail
        }, () => {
            if (this.state.isShowRightDetail) {
                let max_chart_left = document.getElementById("max_chart_" + this.state.single_id)
                max_chart_left.style.cssText = `width: 45%`
                let max_chart_right = document.getElementById("max_chart_right_" + this.state.single_id)
                max_chart_right.style.cssText = `width: 55%`
            } else {
                let max_chart_left = document.getElementById("max_chart_" + this.state.single_id)
                max_chart_left.style.cssText = `width: 100%`
                let max_chart_right = document.getElementById("max_chart_right_" + this.state.single_id)
                max_chart_right.style.cssText = `width: 20px`
            }
            this.judgeResetChart()
        })
    }
    // 搜索
    handleSearch(event) {
        if (!event) return false
        let search_text = event.target.value.trim()
        if (search_text === "") {
            this.setState({
                desired_user_list: this.state.desired_user_list_formal,
                search_text: ""
            })
        } else {
            let desired_user_list = []
            for (let i = 0; i < this.state.desired_user_list_formal.length; i++) {
                if (this.state.desired_user_list_formal[i].content.indexOf(search_text) !== -1) {
                    desired_user_list.push(this.state.desired_user_list_formal[i])
                }
            }
            this.setState({
                desired_user_list: desired_user_list,
                search_text: search_text
            })
        }
    }
    render() {
        const prefix = (
            <img src={cur_icon_search} alt="" className='evaluation-icon-search' />
        )
        return (
            <div className='max-list-popup' id={`max_chart_popup_${this.state.single_id}`} >
                <div className='max-chart-popup-container'>
                    <div className='max-chart-popup-top'>
                        <div className='popup-top-title'>图表展示</div>
                        <div className='popup-delete-icon'>
                            <img src={cur_icon_close_gre} className='cursor' onClick={this.tags_close.bind(this)} alt="" />
                        </div>
                    </div>
                    {/* 图表名字 */}
                    <div className='popup-content-top'>
                        <div className='top-title-wrapper'>
                            {this.state.dataList.name}
                        </div>
                        <div className='top-btn-wrapper' onClick={this.download.bind(this)}>
                            <img src={download_icon} alt="" />
                            <span>下载</span>
                        </div>
                    </div>
                    {/* 图表切换 */}
                    {
                        this.state.dataList.type === 1 || this.state.dataList.type === 2 || this.state.dataList.type === 5 || this.state.dataList.type === 7 || this.state.dataList.type === 8 || this.state.dataList.type === 12 || this.state.dataList.type === 13 || this.state.dataList.type === 15 ? <div className='max-chart-change-wrapper'>
                            <div className={`chart-change-text ${this.state.chart_flag === 0 ? "chart-change-text-selected" : ""}`} onClick={this.handleChangeChart.bind(this, 0)}>图表</div>
                            <div className="chart-change-sign">|</div>
                            <div className={`chart-change-text ${this.state.chart_flag === 1 ? "chart-change-text-selected" : ""}`} onClick={this.handleChangeChart.bind(this, 1)}>列表</div>
                        </div> : ""
                    }
                    {
                        this.state.dataList.type === 3 || this.state.dataList.type === 16 || this.state.dataList.type === 18 ? <div className='max-chart-change-wrapper'>
                            <div className={`chart-change-text ${this.state.chart_flag === 0 ? "chart-change-text-selected" : ""}`} onClick={this.handleChangeChart.bind(this, 0)}>列表</div>
                            <div className="chart-change-sign">|</div>
                            <div className={`chart-change-text ${this.state.chart_flag === 1 ? "chart-change-text-selected" : ""}`} onClick={this.handleWordCloud.bind(this, 1)}>词云</div>
                        </div> : ""
                    }
                    {/* 显示真正的图表 */}
                    <div className='max-chart-wrapper' id={`max_chart_${this.state.single_id}_wrapper`} >
                        <div className={this.state.chart_flag === 1 || this.state.dataList.type === 3 || this.state.dataList.type === 16 || this.state.dataList.type === 18 || this.state.dataList.type === 10 ? "isHide" : "max-chart-wrapper-2"}>
                            <div id={`max_chart_${this.state.single_id}`} className={`echart-container max-preinstall-echart comment_${this.state.single_id} max-chart-left`} onMouseDown={this.onMouseDown.bind(this)}></div>
                            {
                                this.props.desired_user_list === null ? "" :
                                    <div className="max-chart-right-container" id={`max_chart_right_${this.state.single_id}`}>
                                        <div className="max-chart-right-operator" onClick={this.handleShowRightDetail.bind(this)}>
                                            <div className={this.state.isShowRightDetail ? "" : "isHide"}>{"<<"}</div>
                                            <div className={this.state.isShowRightDetail ? "isHide" : ""}>{">>"}</div>
                                        </div>

                                        {/* <div className="max-chart-detail-container"> */}
                                        <div className={this.state.isShowRightDetail ? "max-chart-detail-container" : "isHide"}>
                                            {
                                                this.props.desired_user_list?.length > 0 ?
                                                    <>
                                                        <div className='option-title'>选项：{this.state.bar_option_name}</div>
                                                        <div className='search-wrapper'>
                                                            <Input prefix={prefix} type="text" value={this.state.search_text} placeholder="请输入要搜索的评论" onChange={this.handleSearch.bind(this)} />
                                                        </div>
                                                        <DetailOptionList
                                                            dataList={this.state.desired_user_list}
                                                            blankListHeight={this.state.blankListHeight}
                                                        ></DetailOptionList>
                                                    </>
                                                    :
                                                    <div>暂无数据</div>
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                        <div className={this.state.chart_flag === 0 ? "isHide" : "max-chart-wrapper-2"}>
                            {
                                this.state.dataList.type === 3 || this.state.dataList.type === 16 || this.state.dataList.type === 18 ?
                                    <div className="max-wordcloud-image-wrapper">
                                        {this.props.wordcloud_image ?
                                            <img src={this.props.wordcloud_image} alt="" /> : <div className="wordcloud-image-empty">
                                                <ConfigProvider locale={zhCN}>
                                                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                                </ConfigProvider>
                                            </div>
                                        }
                                    </div> : ""
                            }
                            {
                                this.state.dataList.type === 1 || this.state.dataList.type === 2 || this.state.dataList.type === 5 || this.state.dataList.type === 6 || this.state.dataList.type === 7 || this.state.dataList.type === 8 || this.state.dataList.type === 12 || this.state.dataList.type === 13 ?
                                    <ChartList
                                        isConsumer={this.state.isConsumer}
                                        dataList={this.state.dataList}
                                        isMaxChart={true}
                                        questionType={this.state.dataList.type}
                                        blankListHeight={this.state.blankListHeight}
                                    ></ChartList> : ""
                            }
                            {
                                this.state.dataList.type === 15 ? <MatrixNpsList
                                    isConsumer={this.state.isConsumer}
                                    dataList={this.state.dataList}
                                    isMaxChart={true}
                                    blankListHeight={this.state.blankListHeight}
                                > </MatrixNpsList> : ""
                            }
                        </div>
                        <div className={this.state.chart_flag === 1 ? "isHide" : "max-chart-wrapper-2"}>
                            {
                                this.state.dataList.type === 3 || this.state.dataList.type === 10 || this.state.dataList.type === 18 ?
                                    <BlankList
                                        dataList={this.state.dataList}
                                        survey_type={this.props.survey_type}
                                        isMaxChart={true}
                                        blankListHeight={this.state.blankListHeight}
                                    ></BlankList>
                                    : ""
                            }
                            {
                                this.state.dataList.type === 16 ?
                                    <OpenBlankList
                                        dataList={this.state.dataList}
                                        isMaxChart={true}
                                        blankListHeight={this.state.blankListHeight}
                                    ></OpenBlankList> : ""
                            }
                        </div>
                        {
                            this.state.dataList.type === 11 ?
                                <div className="max-custom-chart-foot">
                                    <div className="max-foot-name max-foot-name-0">
                                        <div className="max-line"></div>
                                        <div className="max-sign"></div>
                                        <div className="max-content">贬损者</div>
                                    </div>
                                    <div className="max-foot-name max-foot-name-1">
                                        <div className="max-line"></div>
                                        <div className="max-sign"></div>
                                        <div className="max-content">被动者</div>
                                    </div>
                                    <div className="max-foot-name max-foot-name-2">
                                        <div className="max-line"></div>
                                        <div className="max-sign"></div>
                                        <div className="max-content">推荐者</div>
                                    </div>
                                </div> : ""
                        }
                    </div>
                </div>
            </div >
        )
    }
}
